









































































































































































































































































































import PageLayout from '@/components/page/PageLayout.vue'
import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'
import TaskApi from '@/api/task'
import AreaApi from '@/api/area'
import { checkCarNo, debounce } from '@/utils/util'
import addTaskMixin from './addTaskMixin'
import { TASKTYPE_MAP } from './authConfig'
let id: any = 0

const debounceSearch = debounce(300)

@Component({
	components: {
		VNodes: {
			functional: true,
			render: (h: any, ctx: any) => ctx.props.vnodes,
		},
	},
})
export default class NewMotion extends Mixins(addTaskMixin) {
	public taskType: any = TASKTYPE_MAP.NEW_MOTION

	private getPush(index: number) {
		if (this.addForm.getFieldValue('locationType') === '1') {
			return index % 2 === 0 ? 0 : 2
		} else {
			return index % 2 === 1 ? 0 : 2
		}
	}

	private onLocationChange() {
		this.addForm.resetFields(['code', 'hospital', 'department'])
	}
}
